<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.addEventListener('DOMContentLoaded', function() {
    const oldText = 'Fluff'; // Text to be replaced
    const newText = 'SoftLanding'; // Replacement text

    // Function to replace text
    function replaceText(element) {
        if (element.hasChildNodes()) {
            element.childNodes.forEach(replaceText);
        } else if (element.nodeType === Text.TEXT_NODE) {
            if (element.textContent.includes(oldText)) {
                element.textContent = element.textContent.replace(new RegExp(oldText, 'g'), newText);
            }
        }
    }

    replaceText(document.body);
});
